import { ref, getCurrentInstance, watch } from 'vue'
import { Message } from 'element-ui'
import { useRoute, useRouter } from 'vue-router/composables'
import { getRouteByName } from '../../../utils/index'
import { menuDataConvert, setDepth, get } from '../../../utils/index'

export function useMenuList(url) {
  const { proxy } = getCurrentInstance()
  const menuList = ref([])
  if (url) {
    get(url).then(([res]) => {
      if (res) {
        const listData = menuDataConvert(res.data, null, true)
        menuList.value = listData
        proxy.$store.commit('updateMenulist', listData)
      }
    })
  } else {
    const menuListPangu = setDepth(proxy.$store.state.menuStore.menuList)
    menuList.value = menuListPangu.some((im) => !!im.id)
      ? menuListPangu
      : menuDataConvert(menuListPangu, null, false)
  }

  return {
    menuList,
  }
}

export function useActiveMenu(menuList) {
  const route = useRoute()
  const activeMenu = ref(null)
  watch(
    () => [route.name, menuList.value],
    () => {
      const nowRouter = getRouteByName(menuList.value, route.name)
      activeMenu.value = nowRouter?.id ?? null
    },
    { immediate: true }
  )

  const router = useRouter()
  const selectMenu = (index) => {
    const toRouter = getRouteByName(menuList.value, index, 'id')
    if (toRouter?.execute == 'openwindow') {
      var win1 = window.open(toRouter.operation)
      if (!win1 || !win1.location) {
        Message.error('被浏览器拦截了，请设置浏览器允许弹出窗口！')
      } else {
        return true
      }
    } else if (toRouter) {
      if (toRouter.name === route.name) return
      const query = toRouter.parameter ?? {}
      if (toRouter.number) {
        query.function = toRouter.number
      }
      router.push({ name: toRouter.name, query })
      return true
    }
  }

  return {
    activeMenu,
    selectMenu,
  }
}
